"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiModelEffort = exports.AiModelProvider = void 0;
var AiModelProvider;
(function (AiModelProvider) {
    AiModelProvider["openAi"] = "openai";
    AiModelProvider["google"] = "google";
    AiModelProvider["anthropic"] = "anthropic";
})(AiModelProvider || (exports.AiModelProvider = AiModelProvider = {}));
var AiModelEffort;
(function (AiModelEffort) {
    AiModelEffort["none"] = "none";
    AiModelEffort["minimal"] = "minimal";
    AiModelEffort["low"] = "low";
    AiModelEffort["medium"] = "medium";
    AiModelEffort["high"] = "high";
    AiModelEffort["xhigh"] = "xhigh";
    AiModelEffort["max"] = "max";
})(AiModelEffort || (exports.AiModelEffort = AiModelEffort = {}));
//# sourceMappingURL=model-card.js.map